import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {CommonService} from '../../../services/common.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';

@Component({
    selector: 'app-initialize-parent',
    templateUrl: './initialize-parent.component.html',
    styleUrls: ['./initialize-parent.component.scss']
})
export class InitializeParentComponent implements OnInit {
    @Input() parentFormGroup: FormGroup;
    confirmPassword: string;
    requestLoading: boolean;
    requestedMobileCode: boolean;
    requestedEmailCode: boolean;
    parentType = [{
        id: 1,
        label: 'Πατέρας'
    }, {
        id: 2,
        label: 'Μητέρα'
    }];

    constructor(private commonService: CommonService,
                public toastService: ToastMessagesService) {
        this.confirmPassword = '';
        this.requestLoading = false;
        this.requestedMobileCode = false;
        this.requestedEmailCode = false;
    }

    ngOnInit(): void {
    }

    disableEnableForm(status: boolean): void {
        if (status) {
            this.parentFormGroup.disable();
        } else {
            this.parentFormGroup.enable();
        }
    }

    async sendMobileOTP() {
        try {
            this.requestLoading = true;
            const result: any = await this.commonService.insertItem('twoStep/register/generateAnonymousMobileOtp',
                {phone: this.parentFormGroup.controls.telephone.value});
            this.requestedMobileCode = true;
            this.toastService.toastMessages(result.object);
        } catch (e) {
            this.toastService.toastErrorMessage(e.message);
        } finally {
            this.requestLoading = false;
        }
    }

    async verifyMobileCode() {
        try {
            this.requestLoading = true;
            const result: any = await this.commonService.insertItem('twoStep/register/validateAnonymousMobileOtp',
                {code: this.parentFormGroup.controls.telephoneOTP.value, phone: this.parentFormGroup.controls.telephone.value});
            if (result.status === 200) {
                this.parentFormGroup.controls.confirmedMobileCode.setValue(true);
            } else {
                this.toastService.toastErrorMessage('O κωδικός επαλήθευσης δεν ήταν σωστός ');
            }
        } catch (e) {
            this.toastService.toastErrorMessage('O κωδικός επαλήθευσης δεν ήταν σωστός ');
        } finally {
            this.requestLoading = false;
        }
    }

    async  sendEmailOTP() {
        try {
            this.requestLoading = true;
            this.disableEnableForm(true);
            const result: any = await this.commonService.insertItem('twoStep/register/generateAnonymousEmailOtp',
                {email: this.parentFormGroup.controls.email.value});
            this.requestedEmailCode = true;
            this.toastService.toastMessages(result.object);
        } catch (e) {
            this.toastService.toastErrorMessage(e.message);
        } finally {
            this.requestLoading = false;
            this.disableEnableForm(false);
        }
    }

    async verifyEmailCode() {
        try {
            this.requestLoading = true;
            const result: any = await this.commonService.insertItem('twoStep/register/validateAnonymousEmailOtp',
                {code: this.parentFormGroup.controls.emailOTP.value, email: this.parentFormGroup.controls.email.value});
            if (result.status === 200) {
                this.parentFormGroup.controls.confirmedEmailCode.setValue(true);
            } else {
                this.toastService.toastErrorMessage('O κωδικός επαλήθευσης δεν ήταν σωστός ');
            }
        } catch (e) {
            // this.toastMessagesService.toastErrorMessage(e.message);
            this.toastService.toastErrorMessage('O κωδικός επαλήθευσης δεν ήταν σωστός ');
        } finally {
            this.requestLoading = false;
        }
    }

    isEmailCodeValid() {
        return this.parentFormGroup.controls.confirmedEmailCode.value === true;
    }

    isTelephoneCodeValid() {
        return this.parentFormGroup.controls.confirmedMobileCode.value === true;
    }
}
